import { formSelector } from '@xcritical/forms';
import { getModalByName, IModal, IStoreWithModal } from '@xcritical/modal';

import {
  INewMessageFormState,
  IStoreWithChat,
  ISearchFormState,
  IMessage,
} from '../types';
import { NEW_MESSAGE_FORM_NAME, SEARCH_FORM_NAME } from '../consts';
import { GROUP_IMPORT_CONFIRM_MODAL, GROUP_IMPORT_MODAL } from '../components';

export const getChatState = (state: IStoreWithChat) => state.chat;

export const getChatMessages = (state: IStoreWithChat): IMessage[] =>
  getChatState(state).currentChat?.msgs || [];

export const getCallIsPending = (state: IStoreWithChat): boolean =>
  getChatState(state).callIsPending;

export const getClientIsMuted = (state: IStoreWithChat): boolean =>
  getChatState(state).isClientMuted;

export const getOpenChatState = (state: IStoreWithChat) =>
  getChatState(state).isOpen;

export const getCurrentChatSelector = (state: IStoreWithChat) =>
  getChatState(state).currentChat;

export const getCurrentCallSelector = (state: IStoreWithChat) =>
  getChatState(state).activeCall;

export const getAvailableLeadsSelector = (state: IStoreWithChat) =>
  getChatState(state).availableLeads;

export const getNewMessageForm = (
  state: IStoreWithChat
): INewMessageFormState => formSelector(state, NEW_MESSAGE_FORM_NAME);

export const getSearchForm = (state: IStoreWithChat): ISearchFormState =>
  formSelector(state, SEARCH_FORM_NAME);

export const storageKeySelector = (clientId?: number): string =>
  clientId ? `token-${clientId}` : 'token-manager';

export const getConfirmModal = (state: IStoreWithModal): IModal =>
  getModalByName(state, GROUP_IMPORT_CONFIRM_MODAL);

export const getGroupImportModal = (state: IStoreWithModal) =>
  getModalByName(state, GROUP_IMPORT_MODAL);
